import { actions, actionTypes, selectors } from 'data'
import { put, select, takeEvery } from 'redux-saga/effects'
import webSocket from 'services/api/webSocket'

import { SendActionType, SubscribeActionType, UnsubscribeActionType } from '../actions'

const subscribe = function* (action: SubscribeActionType) {
  const message = action.payload
  yield put(
    actions.socket.send({
      action: webSocket.action.SUBSCRIBE,
      ...message
    })
  )
}

const unsubscribe = function* (action: UnsubscribeActionType) {
  const { message } = action.payload
  yield put(
    actions.socket.send({
      action: webSocket.action.UNSUBSCRIBE,
      ...message
    })
  )
}

const send = function* (action: SendActionType) {
  const ws = yield select(selectors.socket.getConnection)
  if (!ws) throw new Error(`Can't send message, no connection open. ${action.payload}`)
  ws.send(action.payload)
}

export default function* socketMain() {
  yield takeEvery(actionTypes.socket.SEND, send)
  yield takeEvery(actionTypes.socket.SUBSCRIBE, subscribe)
  yield takeEvery(actionTypes.socket.UNSUBSCRIBE, unsubscribe)
}
